/**
 * Показывать ли на карте вручную отмеченные косяки.
 *
 * Косяк рисуется ДВУМЯ слоями, и это не дублирование: пока сноса нет, отметку
 * держит слой `clusters`, а как только снос посчитан — слой сноса своим кружком
 * `role='origin'`, потому что два кружка в одной точке читаются как два разных
 * наблюдения (`clustersWithoutTrack`). Поэтому и гасить надо оба: тумблер,
 * убирающий только первый слой, оставил бы на карте ровно те косяки, ради
 * которых его и нажимают.
 *
 * Факты вылова тумблер не трогает. Это не наблюдение промысловика, а
 * загруженная отчётность, и своя видимость у неё уже есть — точки и ореол
 * гасятся признаками кабинета (`catch_anonymized`, `catch_halo_hidden`).
 */
import type { DriftCollection } from '../api'

/** Метка источника «косяк» в свойствах точки сноса. */
export const SCHOOL_SOURCE = 'cluster'

/**
 * Коллекция сноса без косяков, когда они выключены.
 *
 * Включено — возвращаем ТУ ЖЕ ссылку, а не копию: тумблер по умолчанию включён,
 * и новый объект на каждом рендере сбрасывал бы мемоизацию слоя даром.
 */
export function applySchoolsVisibility(
  fc: DriftCollection | null,
  shown: boolean,
): DriftCollection | null {
  if (!fc || shown) return fc
  return {
    ...fc,
    features: fc.features.filter(f => f.properties.source !== SCHOOL_SOURCE),
  }
}
